var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMody(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6748 10.7966L13.1748 2.2966C12.6748 1.7966 11.9748 1.9966 11.6748 2.3966L2.57475 15.3966C1.67475 16.5966 1.87475 18.1966 2.87475 19.2966L4.67475 21.0966C5.67475 22.0966 7.37475 22.2966 8.57475 21.3966L21.5748 12.2966C22.0748 11.9966 22.0748 11.1966 21.6748 10.7966ZM12.5748 4.5966L19.3748 11.3966L18.4748 11.9966H7.37475L12.5748 4.5966ZM10.0748 17.8966L6.17475 13.9966H15.6748L10.0748 17.8966ZM6.17475 19.6966L4.37475 17.8966C3.97475 17.4966 3.87475 16.9966 4.17475 16.4966L4.87475 15.4966L8.37475 18.9966L7.37475 19.6966C6.97475 20.0966 6.47475 19.9966 6.17475 19.6966Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMody);
export default __webpack_public_path__ + "static/media/mody.f3e9bf40.svg";
export { ForwardRef as ReactComponent };